import React, { Component, Ref } from "react";
import { _ReactPixi, withPixiApp, Container } from "@inlet/react-pixi";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import UIManager from "../../core/components/ui/UiBuilder";
import * as PIXI from 'pixi.js';
import { actions as layoutssActions } from "../../core/reducers/layoutsStateReducer";
import { isMobile } from "react-device-detect";
import { TIMER } from "../../core/utills";
import { actions as randomWildActions } from "../../gamereducer/gameRandomWildReducer";
import { actions as streakEffectActions } from "../../gamereducer/streakEffectReducer";
import withSkullContainerConfiguration from "./configuration/withrandomwildconfiguration";
import { actions as symbolActions } from "../../core/reducers/symbolStateReducer";
import { actions as soundActions } from "../../core/reducers/soundReducer";
import { Baseparticle } from "../../core/components/effect/baseparticle";
import { PathTween } from "../../core/components/effect/pathtween";
import { configGame } from "../../data/config"
import { actions as winShowerActions } from "../../gamereducer/winShowerReducer";
import { actions as basegameAction } from "../../core/reducers/baseGameReducer";
import { actions as freegameAction } from "../../core/reducers/freeGameReducer";
import { actions as flowManagerAction } from "../../core/reducers/flowManagerReducer";
import { actions as buttonActions } from "../../core/reducers/buttonPanelReducer";
import { actions as multiplierActions } from "../../gamereducer/multiplierReducer";
import { actions as winCelebrationActions } from "../../gamereducer/winCelebrationReducer";
import { actions as winpresentationAction } from "../../core/reducers/winPresentationReducer";
import { actions as keyboardListenerActions } from "../../core/reducers/keyboardListenerReducer";
interface IStore {
    [x: string]: any;
}

interface IProps {
    [x: string]: any;
}

interface IStateToProps {
    [x: string]: any;
}

interface IDispatchToProps {

}

interface IState {
    [x: string]: any;
}

class RandomWild extends Component<IProps, IState> {
    protected app: PIXI.Application;
    protected randomWild: any;
    protected ui_mode: string;
    protected displayUI: any;
    protected xAxis: number = configGame.REEL_CONTAINER_X;
    protected yAxis: number = configGame.REEL_CONTAINER_Y;
    protected counter: number = 0;

    protected savePositionLength: number = 0;
    protected animX: number = 0;
    protected animY: number = 0;
    protected featureLevel = 2;
    protected winCelebrationMinimumValue: number = 20;
    protected extraFreeSpins: number = 1;
    protected storePreviousFreeSpinCount: number = 0;
    protected constantT1: number = 100;
    protected constantT2: number = 2000;
    private bigWinTimer: number = 8000;
    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.state = {
            uiElements: [],
            lang: "en"
        }
        this.randomWild = React.createRef();
        if (isMobile) {
            this.ui_mode = "mobile";
        } else {
            this.ui_mode = "desktop";
        }

        this.displayUI = this.props.data.COMPONENTS.filter(this.checkUiMode.bind(this));

    }

    checkUiMode(uimodeobj: any) {

        if (uimodeobj.uimode === undefined) {
            uimodeobj.uimode = "both";
        }
        if (uimodeobj.uimode === "both" || uimodeobj.uimode === this.ui_mode) {
            return uimodeobj;
        }
    }


    bindUI() {
        this.layoutChange(this.props.layoutMode);
        setTimeout(() => {
            // this.changeCharacterSpineAnimationName();
        }, 4000);
    }


    initializeObjectInVariable() {

    }

    handleRotation(isFeatureShown: any) {

    }

    showHighlightedSkull(nextProps: any) {

    }

    componentDidMount() {
        this.initializeObjectInVariable();
        this.bindUI();
    }
    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {


        if (nextProps.startRandomWild !== this.props.startRandomWild
            || nextProps.randomWildsPositions !== this.props.randomWildsPositions
            || nextProps.inFreeGame !== this.props.inFreeGame
            || nextProps.randomWildRunning !== this.props.randomWildRunning
            || nextProps.spinStart !== this.props.spinStart
            || nextProps.updateDisplayWinDuration !== this.props.updateDisplayWinDuration
            || nextProps.bodyBuilderSelected !== this.props.bodyBuilderSelected
            || nextProps.reel_data !== this.props.reel_data
            || nextProps.soundIsPlaying !== this.props.soundIsPlaying
            || nextProps.allSoundSFXStop !== this.props.allSoundSFXStop
        ) {
            if (nextProps.startRandomWild && nextProps.startRandomWild !== this.props.startRandomWild) {
                this.counter = 1;


                this.changeCharacterSpineAnimationName();
            }

            if (nextProps.updateDisplayWinDuration !== this.props.updateDisplayWinDuration) {
                this.props.configGame.DISPLAY_ALL_WIN_DURATION = nextProps.updateDisplayWinDuration;
            }
            return false;
        }


        return true;
    }



    layoutChange(currentLayout: string) {
        this.displayUI.map((data: any,) => {
            if (data.layout === true) {
                this.props.setApplicationLayoutObject(data.name);
            }
        })
    }




    changeEffectAxisAccordingToScreen() {
        if (isMobile && window.innerWidth < window.innerHeight) {
            this.xAxis = configGame.RANDOM_WILD_EFFECT_PORTRAIT_X;
            this.yAxis = configGame.RANDOM_WILD_EFFECT_PORTRAIT_Y;

        }
        else {
            this.xAxis = configGame.REEL_CONTAINER_X;
            this.yAxis = configGame.REEL_CONTAINER_Y;
        }
    }
    changeCharacterSpineAnimationName() {

        let animName = this.getAnimationName()
        let characterAnim = this.props.bodyBuilderSelected ? UIManager.getRef(animName + this.ui_mode) : UIManager.getRef(animName + this.ui_mode)
        let spineName = "Action";
        if (characterAnim.spineAnimName === "Idle" && !this.props.randomWildRunning) {
            characterAnim.children[0].state.onComplete = () => {
                if (!this.props.randomWildRunning) {
                    this.props.setRandomWildRunning(true);
                    characterAnim.spineAnimName = spineName;
                    characterAnim.children[0].state.setAnimation(0, spineName, false);
                    let timer = TIMER.TimerManager.createTimer(500);
                    timer.on('end', () => {
                        this.featureLevel = 2;

                        this.addPathTween()
                        if (characterAnim.spineAnimName === "Action") {
                            characterAnim.children[0].state.onComplete = () => {
                                characterAnim.children[0].state.setAnimation(0, "Idle", false);
                                characterAnim.spineAnimName = "Idle";

                            }
                        }
                    });
                    timer.start();

                }

            }
        }

    }

    getAnimationName(): string {

        let animName = this.props.bodyBuilderSelected ? "bodyBuilderCharacterIdle_" : "skeletonCharacterIdle_"
        if (this.props.inFreeGame) {
            animName = this.props.bodyBuilderSelected ? "fg_bodyBuilderCharecterIdle_" : "fg_skeletonCharacterIdle_"
        }
        return animName;
    }

    particleConfig() {
        let config = {
            "alpha": {
                "start": 1,
                "end": 0.3
            },
            "scale": {
                "start": 0.5,
                "end": 0.5,
                "minimumScaleMultiplier": 1
            },
            "color": {
                "start": "#fce324",
                "end": "#ff9100"
            },
            "speed": {
                "start": 0,
                "end": 0,
                "minimumSpeedMultiplier": 1
            },
            "acceleration": {
                "x": 0,
                "y": 0
            },
            "maxSpeed": 0,
            "startRotation": {
                "min": 0,
                "max": 0
            },
            "noRotation": false,
            "rotationSpeed": {
                "min": 0,
                "max": 0
            },
            "lifetime": {
                "min": 0.2,
                "max": 0.2
            },
            "blendMode": "Add",
            "frequency": 0.001,
            "emitterLifetime": -1,
            "maxParticles": 2000,
            "pos": {
                "x": 0,
                "y": 0
            },
            "addAtBack": true,
            "spawnType": "point"
        }
        return config;
    }

    addWildBorder(x_pos: any, y_pos: any) {

    }

    shootMultipleParticleOnReel(multipleOtherPos: any, startWildPos: any) {
        if (this.props.soundIsPlaying && !this.props.allSoundSFXStop) {
            this.props.playSound([{ name: "symbolToWilds", loop: false }]);
        }
        this.changeEffectAxisAccordingToScreen();
        this.props.showStreakAnimation(false)
        let particle = UIManager.getRef("Particle_01")
        let mainWild = startWildPos

        let main_x_pos = this.xAxis + mainWild[0] * configGame.SYMBOL_WIDTH + configGame.SYMBOL_WIDTH / 2
        let main_y_pos = this.yAxis + mainWild[1] * configGame.SYMBOL_HEIGHT + configGame.SYMBOL_HEIGHT / 2

        let wildPosArr = multipleOtherPos;
        let lastX: any = 0, lastY: any = 0
        wildPosArr.forEach((wildPos: any, index: any) => {
            if (wildPos) {
                //animObj.visible = true;
                let animObj = new Baseparticle(particle.parent, particle.texture, this.particleConfig(), "path");

                animObj.playOnceAndDestroy()
                let Y_adjustment = this.props.bodyBuilderSelected ? 0 : 30
                let x_pos = this.xAxis + wildPos[0] * configGame.SYMBOL_WIDTH + configGame.SYMBOL_WIDTH / 2
                let y_pos = this.yAxis + wildPos[1] * configGame.SYMBOL_HEIGHT + configGame.SYMBOL_HEIGHT / 2 - (Y_adjustment)

                let x_diff = (mainWild[0] - wildPos[0])
                let y_diff = (mainWild[1] - wildPos[1])
                let diagonalAdjustment = 0;
                if ((wildPos[0] - wildPos[1]) === 0) {
                    diagonalAdjustment = configGame.SYMBOL_HEIGHT * 2
                }
                let mid_x, mid_y = 0
                if (x_diff === 0) {
                    x_diff = 1
                }
                if (y_diff === 0) {
                    y_diff = 1
                }
                if (x_diff >= 0) {
                    mid_x = this.xAxis + ((x_diff) * configGame.SYMBOL_WIDTH)
                } else {
                    mid_x = this.xAxis + ((-x_diff) * configGame.SYMBOL_WIDTH) + (mainWild[0] * configGame.SYMBOL_WIDTH)
                }
                if (y_diff >= 0) {
                    mid_y = this.yAxis + ((y_diff) * configGame.SYMBOL_HEIGHT)
                } else {
                    mid_y = this.yAxis + ((-y_diff) * configGame.SYMBOL_HEIGHT) + ((mainWild[1] * configGame.SYMBOL_HEIGHT)) - diagonalAdjustment
                }
                animObj.resetPositionTracking()
                let newTween = new PathTween(
                    animObj,
                    [
                        { x: main_x_pos, y: main_y_pos },

                        { x: mid_x, y: mid_y },

                        { x: x_pos, y: y_pos },
                    ],
                    .3,
                    "bezier",
                    "easeLinear", null, false, false, (e: any) => {
                        if (e.target.x == undefined) {
                            e.target.x = 0
                        }
                        if (e.target.y == undefined) {
                            e.target.y = 0
                        }
                        if (e.target.object.x == undefined) {
                            e.target.object.x = 0
                        }
                        if (e.target.object.y == undefined) {
                            e.target.object.y = 0
                        }


                        let deltaX = -lastX + e.target.object.x
                        let deltaY = -lastY + e.target.object.y

                        particle.x = deltaX
                        particle.y = deltaY
                        if ((e.target.object.x === 0 && e.target.object.y === 0)) {
                            e.target.object.startAlpha.value = 0
                            e.target.object.startScale.value = 0


                        }
                        if (!(e.target.object.x === 0 && e.target.object.y === 0)) {
                            e.target.object.startAlpha.value = 1
                            e.target.object.startScale.value = 0.5
                            animObj.updateOwnerPos(e.target.object.x, e.target.object.y);
                        }


                        lastX = e.target.object.x;
                        lastY = e.target.object.y;
                    }, () => {
                        let gameScreen: any = UIManager.getRef("mainPageContainer");

                        particle.visible = false;
                        let timer = TIMER.TimerManager.createTimer(500);
                        //this.addWildBorder(x_pos, y_pos)
                        if (index === wildPosArr.length - 1) {
                            this.props.setStreakList(wildPosArr)
                            this.props.showStreakAnimation(true)
                            if (this.featureLevel === 3) {
                                let nextTimer = TIMER.TimerManager.createTimer(2000);
                                nextTimer.on('end', () => {
                                    this.addPathTweenLevel3()
                                });
                                nextTimer.start();
                            }

                        }
                        this.updateReelDataSymbols(wildPos);
                        timer.on('end', () => {

                            animObj.cleanup();
                            animObj.destroy();

                            this.callNextSpin();

                        });
                        timer.start();
                    }
                );
                newTween.start();
            }
        })

    }
    callNextSpin() {
        if (this.props.inAutoplay || this.props.inFreeGame) {

            if (this.props.winAmount <= 0) {

                if (this.counter == 1) {

                    this.counter++;
                    let nextTimer = TIMER.TimerManager.createTimer(2400);
                    nextTimer.on('end', () => {
                        // this.playWinAnim();
                        this.props.nextAutoplay();
                        this.props.nextFreegame();
                        this.counter = 0;

                    });
                    nextTimer.start();
                }


            }
            else {

                if (this.props.totalCascadeCount == 0) {

                    if (this.props.winAmount > 0 && this.props.transitionBalance == 0) {

                        this.playWinAnim();
                    }
                    else {

                        this.props.nextAutoplay();
                        this.props.nextFreegame();
                    }


                }
            }
        }
        else {

            if (this.props.totalCascadeCount <= 0 && this.props.totalCascadeCount == 0) {

                if (this.props.winAmount > 0 && this.props.transitionBalance == 0) {


                    this.playWinAnim();
                    this.props.setMultiplierValue(1);
                }
                else {
                    this.props.setAllButtonEnable();
                    this.props.setMultiplierValue(1);
                }

            }
        }
    }
    playWinAnim() {

        let checkingCondition: boolean = true;
        let totalWinAmount = this.props.totalCreditWinAmount;
        let storeBetValue = this.props.betList[this.props.currentBetIndex];
        if (this.props.hideNegativeWins && storeBetValue > totalWinAmount) {
            checkingCondition = false;
        }
        this.props.stopWinPresentation();
        let nextFlowTimer = 2000;
        if (checkingCondition && this.props.totalCreditWinAmount < this.winCelebrationMinimumValue * this.props.betList[this.props.currentBetIndex]) {

            this.props.winShowerShow(true);
            let timer = TIMER.TimerManager.createTimer(250);
            timer.on('end', () => {
                this.props.winShowerStart(true, totalWinAmount);

            });
            timer.start();
            nextFlowTimer = 5000;

        }

        else {


            if (this.props.totalCreditWinAmount / this.constantT1 >= this.winCelebrationMinimumValue * this.props.betList[this.props.currentBetIndex] / this.constantT1) {

                this.props.winCelebrationShow(true);
                this.props.setWinCelebrationForKeyboardListener(true);
                let timer = TIMER.TimerManager.createTimer(340);
                timer.on('end', (e: any, data: any) => {
                    this.props.winCelebrationStart(true, this.props.displayInCoins ? "Coin" : "Cash");
                })
                timer.start();
                this.props.setAllButtonDisable();
                nextFlowTimer = this.bigWinTimer;

            }
            else {

                if ((this.props.inAutoplay || this.props.inAutoplay) || this.props.featureType == "FREEGAME") {


                    this.props.nextAutoplay();
                    this.props.nextFreegame();
                }
                this.props.setAllButtonEnable();
            }
        }
    }
    shootMultipleParticleOnReelLevel3(multipleOtherPos: any, startWildPos: any) {
        if (this.props.soundIsPlaying && !this.props.allSoundSFXStop) {
            this.props.playSound([{ name: "symbolToWilds", loop: false }]);
        }
        this.changeEffectAxisAccordingToScreen();
        this.props.showStreakAnimation(false)
        let particle = UIManager.getRef("Particle_01")
        let mainWild = startWildPos

        let main_x_pos = this.xAxis + mainWild[0] * configGame.SYMBOL_WIDTH + configGame.SYMBOL_WIDTH / 2
        let main_y_pos = this.yAxis + mainWild[1] * configGame.SYMBOL_HEIGHT + configGame.SYMBOL_HEIGHT / 2

        let wildPosArr = multipleOtherPos;
        let lastX: any = 0, lastY: any = 0
        wildPosArr.forEach((wildPos: any, index: any) => {
            if (wildPos) {
                //animObj.visible = true;
                let animObj = new Baseparticle(particle.parent, particle.texture, this.particleConfig(), "path");

                animObj.playOnceAndDestroy()
                let Y_adjustment = this.props.bodyBuilderSelected ? 0 : 30
                let x_pos = this.xAxis + wildPos[0] * configGame.SYMBOL_WIDTH + configGame.SYMBOL_WIDTH / 2
                let y_pos = this.yAxis + wildPos[1] * configGame.SYMBOL_HEIGHT + configGame.SYMBOL_HEIGHT / 2 - (Y_adjustment)

                let x_diff = (mainWild[0] - wildPos[0])
                let y_diff = (mainWild[1] - wildPos[1])
                let diagonalAdjustment = 0;
                if ((wildPos[0] - wildPos[1]) === 0) {
                    diagonalAdjustment = configGame.SYMBOL_HEIGHT * 2
                }
                let mid_x, mid_y = 0
                if (x_diff === 0) {
                    x_diff = 1
                }
                if (y_diff === 0) {
                    y_diff = 1
                }
                if (x_diff >= 0) {
                    mid_x = this.xAxis + ((x_diff) * configGame.SYMBOL_WIDTH)
                } else {
                    mid_x = this.xAxis + ((-x_diff) * configGame.SYMBOL_WIDTH) + (mainWild[0] * configGame.SYMBOL_WIDTH)
                }
                if (y_diff >= 0) {
                    mid_y = this.yAxis + ((y_diff) * configGame.SYMBOL_HEIGHT)
                } else {
                    mid_y = this.yAxis + ((-y_diff) * configGame.SYMBOL_HEIGHT) + ((mainWild[1] * configGame.SYMBOL_HEIGHT)) - diagonalAdjustment
                }
                animObj.resetPositionTracking()
                let newTween = new PathTween(
                    animObj,
                    [
                        { x: main_x_pos, y: main_y_pos },

                        { x: mid_x, y: mid_y },

                        { x: x_pos, y: y_pos },
                    ],
                    .3,
                    "bezier",
                    "easeLinear", null, false, false, (e: any) => {
                        if (e.target.x == undefined) {
                            e.target.x = 0
                        }
                        if (e.target.y == undefined) {
                            e.target.y = 0
                        }
                        if (e.target.object.x == undefined) {
                            e.target.object.x = 0
                        }
                        if (e.target.object.y == undefined) {
                            e.target.object.y = 0
                        }


                        let deltaX = -lastX + e.target.object.x
                        let deltaY = -lastY + e.target.object.y

                        particle.x = deltaX
                        particle.y = deltaY
                        if ((e.target.object.x === 0 && e.target.object.y === 0)) {
                            e.target.object.startAlpha.value = 0
                            e.target.object.startScale.value = 0


                        }
                        if (!(e.target.object.x === 0 && e.target.object.y === 0)) {
                            e.target.object.startAlpha.value = 1
                            e.target.object.startScale.value = 0.5
                            animObj.updateOwnerPos(e.target.object.x, e.target.object.y);
                        }


                        lastX = e.target.object.x;
                        lastY = e.target.object.y;
                    }, () => {
                        let gameScreen: any = UIManager.getRef("mainPageContainer");

                        particle.visible = false;
                        let timer = TIMER.TimerManager.createTimer(500);
                        //this.addWildBorder(x_pos, y_pos)
                        if (index === wildPosArr.length - 1) {
                            this.props.setStreakList(wildPosArr)
                            this.props.showStreakAnimation(true)

                        }
                        this.updateReelDataSymbols(wildPos);
                        timer.on('end', () => {


                            animObj.cleanup();
                            animObj.destroy()

                        });
                        timer.start();
                    }
                );
                newTween.start();
            }
        })

    }
    setAnimPosition() {
        if (isMobile && window.innerWidth > window.innerHeight) {
            this.animX = this.props.bodyBuilderSelected ? 1750 : 1340;
            this.animY = this.props.bodyBuilderSelected ? 825 : 480;
        }
        else if (isMobile && window.innerWidth < window.innerHeight) {
            this.animX = this.props.bodyBuilderSelected ? 992 : 708;
            this.animY = this.props.bodyBuilderSelected ? 1530 : 1300;
        }
        else {
            this.animX = this.props.bodyBuilderSelected ? 1815 : 1440;
            this.animY = this.props.bodyBuilderSelected ? 800 : 460;
        }

    }
    addPathTween() {


        if (this.props.soundIsPlaying && !this.props.allSoundSFXStop) {
            this.props.playSound([{ name: "energyToSymbol", loop: false }]);
        }
        this.props.showStreakAnimation(false)
        this.changeEffectAxisAccordingToScreen();
        this.setAnimPosition();
        let particle = UIManager.getRef("Particle_01")
        //particle && (particle.visible = true)
        let animObj = new Baseparticle(particle.parent, particle.texture, this.particleConfig(), "path");
        if (!this.props.bodyBuilderSelected) {
            particle.position.set(1450, 520)
        } else {
            (isMobile && window.innerWidth < window.innerHeight) ? particle.position.set(1038, 1592) : particle.position.set(1815, 800);
            //particle.position.set(1815, 800)
            //   particle.position.set(1038, 1592)
            // 1038, 1592
        }
        animObj.playOnceAndDestroy()
        if (this.props.randomWildsPositions.length > 5) {
            this.featureLevel = 3
        }
        let allPositions = this.props.randomWildsPositions.slice();
        let startIndex;

        (allPositions.length < 2) ? startIndex = allPositions.length - 1 : startIndex = 2;

        let wildPos = allPositions[startIndex];

        let multipleOtherPos = allPositions
        multipleOtherPos.splice(startIndex, 1);

        let lastX: any = 0, lastY: any = 0;

        this.savePositionLength = allPositions.length;
        if (animObj) {

            particle.visible = true;
            let Y_adjustment = this.props.bodyBuilderSelected ? 0 : 30

            let x_pos = this.xAxis + wildPos[0] * configGame.SYMBOL_WIDTH + configGame.SYMBOL_WIDTH / 2;
            let y_pos = this.yAxis + wildPos[1] * configGame.SYMBOL_HEIGHT + configGame.SYMBOL_HEIGHT / 2 - (Y_adjustment);
            let mid_x = x_pos + configGame.SYMBOL_WIDTH * 2
            let mid_y = y_pos - configGame.SYMBOL_WIDTH
            animObj.resetPositionTracking()

            let newTween = new PathTween(
                animObj,
                [
                    { x: this.animX, y: this.animY },

                    { x: mid_x, y: mid_y },

                    { x: x_pos, y: y_pos },
                ],
                .3,
                "bezier",
                "easeLinear", null, false, false, (e: any) => {
                    if (e.target.x == undefined) {
                        e.target.x = 0
                    }
                    if (e.target.y == undefined) {
                        e.target.y = 0
                    }
                    if (e.target.object.x == undefined) {
                        e.target.object.x = 0
                    }
                    if (e.target.object.y == undefined) {
                        e.target.object.y = 0
                    }


                    let deltaX = -lastX + e.target.object.x
                    let deltaY = -lastY + e.target.object.y



                    particle.x = deltaX
                    particle.y = deltaY
                    if ((e.target.object.x === 0 && e.target.object.y === 0)) {
                        e.target.object.startAlpha.value = 0
                        e.target.object.startScale.value = 0


                    }
                    if (!(e.target.object.x === 0 && e.target.object.y === 0)) {
                        e.target.object.startAlpha.value = 1
                        e.target.object.startScale.value = 0.5
                        animObj.updateOwnerPos(e.target.object.x, e.target.object.y);
                    }

                    lastX = e.target.object.x;
                    lastY = e.target.object.y;
                }, () => {
                    let gameScreen: any = UIManager.getRef("mainPageContainer");
                    this.updateReelDataSymbols(wildPos);
                    this.props.setStreakList([wildPos])
                    this.props.showStreakAnimation(true)
                    particle.visible = false;
                    let timer = TIMER.TimerManager.createTimer(500);

                    timer.on('end', () => {
                        animObj.cleanup();
                        animObj.destroy()
                        let innerTimer = TIMER.TimerManager.createTimer(1000);

                        innerTimer.on('end', () => {
                            if (this.featureLevel === 3) {
                                let maxVal = 4
                                let newArr1 = multipleOtherPos.slice(0, maxVal);
                                this.shootMultipleParticleOnReel(newArr1, wildPos)
                            } else {
                                this.shootMultipleParticleOnReel(multipleOtherPos, wildPos)
                            }


                            if (this.savePositionLength < 2) {

                                this.callNextSpin();

                            }
                        });
                        innerTimer.start();
                    });
                    timer.start();



                }
            );
            newTween.start();
        }

    }

    addPathTweenLevel3() {
        if (this.props.soundIsPlaying && !this.props.allSoundSFXStop) {
            this.props.playSound([{ name: "energyToSymbol", loop: false }]);
        }
        this.props.showStreakAnimation(false)
        this.changeEffectAxisAccordingToScreen();
        this.setAnimPosition();
        let particle = UIManager.getRef("Particle_01")
        //particle && (particle.visible = true)
        let animObj = new Baseparticle(particle.parent, particle.texture, this.particleConfig(), "path");
        if (!this.props.bodyBuilderSelected) {
            particle.position.set(1450, 520)
        } else {
            (isMobile && window.innerWidth < window.innerHeight) ? particle.position.set(1038, 1592) : particle.position.set(1815, 800);
            //particle.position.set(1815, 800)
            //   particle.position.set(1038, 1592)
            // 1038, 1592
        }
        animObj.playOnceAndDestroy()
        let allPositions = this.props.randomWildsPositions.slice();
        let startIndex = 2

        let wildPos = allPositions[startIndex];

        let multipleOtherPos = allPositions
        multipleOtherPos.splice(startIndex, 1);

        let lastX: any = 0, lastY: any = 0
        if (animObj) {
            particle.visible = true;
            let Y_adjustment = this.props.bodyBuilderSelected ? 0 : 30
            let x_pos = this.xAxis + wildPos[0] * configGame.SYMBOL_WIDTH + configGame.SYMBOL_WIDTH / 2;
            let y_pos = this.yAxis + wildPos[1] * configGame.SYMBOL_HEIGHT + configGame.SYMBOL_HEIGHT / 2 - (Y_adjustment);
            let mid_x = x_pos + configGame.SYMBOL_WIDTH * 2
            let mid_y = y_pos - configGame.SYMBOL_WIDTH
            animObj.resetPositionTracking()

            let newTween = new PathTween(
                animObj,
                [
                    { x: this.animX, y: this.animY },

                    { x: mid_x, y: mid_y },

                    { x: x_pos, y: y_pos },
                ],
                .3,
                "bezier",
                "easeLinear", null, false, false, (e: any) => {
                    if (e.target.x == undefined) {
                        e.target.x = 0
                    }
                    if (e.target.y == undefined) {
                        e.target.y = 0
                    }
                    if (e.target.object.x == undefined) {
                        e.target.object.x = 0
                    }
                    if (e.target.object.y == undefined) {
                        e.target.object.y = 0
                    }


                    let deltaX = -lastX + e.target.object.x
                    let deltaY = -lastY + e.target.object.y



                    particle.x = deltaX
                    particle.y = deltaY
                    if ((e.target.object.x === 0 && e.target.object.y === 0)) {
                        e.target.object.startAlpha.value = 0
                        e.target.object.startScale.value = 0


                    }
                    if (!(e.target.object.x === 0 && e.target.object.y === 0)) {
                        e.target.object.startAlpha.value = 1
                        e.target.object.startScale.value = 0.5
                        animObj.updateOwnerPos(e.target.object.x, e.target.object.y);
                    }

                    lastX = e.target.object.x;
                    lastY = e.target.object.y;
                }, () => {
                    let gameScreen: any = UIManager.getRef("mainPageContainer");
                    this.updateReelDataSymbols(wildPos);
                    this.props.setStreakList([wildPos])
                    this.props.showStreakAnimation(true)
                    particle.visible = false;
                    let timer = TIMER.TimerManager.createTimer(500);

                    timer.on('end', () => {
                        animObj.cleanup();
                        animObj.destroy()
                        let innerTimer = TIMER.TimerManager.createTimer(1000);

                        innerTimer.on('end', () => {
                            let maxVal = 4
                            let newArr2 = multipleOtherPos.slice(maxVal, multipleOtherPos.length);
                            this.shootMultipleParticleOnReelLevel3(newArr2, wildPos)
                        });
                        innerTimer.start();
                    });
                    timer.start();



                }
            );
            newTween.start();
        }

    }

    compare_prop_y(a: any, b: any) {
        // a should come before b in the sorted order
        if (a.y < b.y) {
            return -1;
            // a should come after b in the sorted order
        } else if (a.y > b.y) {
            return 1;
            // a and b are the same
        } else {
            return 0;
        }
    }
    updateReelDataSymbols(wildPos: any) {
        let reel_data = this.props.reel_data;

        for (let i: number = 0; i < 6; i++) {
            let reelGrid = UIManager.getRef("gridGameCoulmn" + i);
            reelGrid.children.sort(this.compare_prop_y)

        }
        //let positions = this.props.randomWildsPositions
        let positions = wildPos

        let timer = TIMER.TimerManager.createTimer(500);
        timer.on('end', (e: any) => {
            e.remove();
            let reelGrid = UIManager.getRef("gridGameCoulmn" + positions[0]);
            let symbolContainer: any = reelGrid.children[positions[1]];
            let xpos = symbolContainer.x;
            let ypos = symbolContainer.y;
            reel_data.stopReels[positions[0]][positions[1]] = 10;
            this.props.onUpdateSymbolOnReel(symbolContainer, 10, false);
            symbolContainer.y = ypos
            symbolContainer.visible = true;
            // this.props.nextAutoplay();
            // this.props.nextFreegame();

        });
        timer.start();


    }


    render() {

        return (
            <UIManager id={"RandomWild"} name={"RandomWild"} type={"Container"}
                ref={i => this.randomWild = i} configGame={this.props.configGame}
                app={this.app} >
                {
                    this.displayUI && this.displayUI.map((i: any) =>
                        <UIManager key={`UIManager-${Math.random()}`} langObj={this.props.langObj} type={i.type}
                            id={i.id} {...i} app={this.app} configGame={this.props.configGame}
                            scope={this} />
                    )
                }
            </UIManager>

        )
    }

}

export default withPixiApp(connect(
    (state: Pick<IStore, "behaviourState" | 'betPanelState' | 'basegameState' | 'applicationState' | 'soundState' | 'freegameState' | 'RandomWildState' | 'gridsState' | 'skullState' | 'giantWildState' | 'randomWildsState'>): IStateToProps =>
    ({
        randomWildsPositions: state.randomWildsState.randomWildsPositions,
        startRandomWild: state.randomWildsState.startRandomWild,
        randomWildRunning: state.randomWildsState.randomWildRunning,
        bodyBuilderSelected: state.giantWildState.bodyBuilderSelected,
        reel_data: state.gridsState.reel_data,
        updateDisplayWinDuration: state.RandomWildState.updateDisplayWinDuration,
        inFreeGame: state.freegameState.inFreeGame,
        allSoundSFXStop: state.soundState.allSoundSFXStop,
        soundIsPlaying: state.soundState.soundIsPlaying,
        inAutoplay: state.basegameState.inAutoplay,
        winAmount: state.basegameState.winAmount,
        betList: state.betPanelState.coinList,
        totalCreditWinAmount: state.behaviourState.totalCreditWinAmount,
        currentBetIndex: state.betPanelState.selectedCoin,
        totalCascadeCount: state.gridsState.totalCascadeCount,
        transitionBalance: state.behaviourState.transitionBalance,

    }),
    (dispatch: Dispatch): IDispatchToProps => ({
        playSound: (soundName: any): any => dispatch(soundActions.playSound(soundName)),
        setApplicationLayoutObject: (layoutobjectlist: any): any => dispatch(layoutssActions.setApplicationLayoutObject(layoutobjectlist)),
        setRandomWildRunning: (gianWildRunning: any): any => dispatch(randomWildActions.setRandomWildRunning(gianWildRunning)),
        setStreakList: (arr: any): any => dispatch(streakEffectActions.setStreakList(arr)),
        showStreakAnimation: (value: any): any => dispatch(streakEffectActions.showStreakAnimation(value)),
        onUpdateSymbolOnReel: (symbol: any, symbolId: number, randomSymbol: boolean): any => dispatch(symbolActions.setUpdatedSymbol(symbol, symbolId, randomSymbol)),
        nextAutoplay: (): any => dispatch(basegameAction.nextAutoplay()),
        nextFreegame: (): any => dispatch(freegameAction.nextFreegame()),
        winShowerStart: (startWinShower: boolean, winShowerAmount: number): any => dispatch(winShowerActions.winShowerStart(startWinShower, winShowerAmount)),
        winShowerShow: (showWinShower: boolean): any => dispatch(winShowerActions.winShowerShow(showWinShower)),
        flowManagerCalled: (callFlowManager: boolean): any => dispatch(flowManagerAction.flowManagerCalled(callFlowManager)),
        setAllButtonEnable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonEnable(exceptBtnList)),
        setMultiplierValue: (multiplierCurrentValue: any): any => dispatch(multiplierActions.setMultiplierValue(multiplierCurrentValue)),
        winCelebrationStart: (startWinCelebration: boolean, showAmount: string): any => dispatch(winCelebrationActions.winCelebrationStart(startWinCelebration, showAmount)),
        winCelebrationShow: (showWinCelebration: boolean): any => dispatch(winCelebrationActions.winCelebrationShow(showWinCelebration)),
        stopWinPresentation: (): any => dispatch(winpresentationAction.stopWinPresentation()),
        setWinCelebrationForKeyboardListener: (winCelebrationForKeyBoardListener: boolean): any => dispatch(keyboardListenerActions.setWinCelebrationForKeyboardListener(winCelebrationForKeyBoardListener)),
        setAllButtonDisable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonDisable(exceptBtnList)),
    }))(withSkullContainerConfiguration(RandomWild)));